module.exports = "../../../../platform/assets/pageMainIcon/ig-business-setting-2.svg";